import React from 'react';

import { useTranslation } from '@modernloop/i18n';
import { Dialog } from '@modernloop/shared/components';

type Props = {
  onClose: () => void;
  onContinue: () => void;
};

const AvailabilityCloseAlertModal = ({ onClose, onContinue }: Props) => {
  const { t } = useTranslation('hiring-dashboard-schedule');

  return (
    <Dialog
      open
      dataTestId="schedule-content-actions-availability-request-alert-dialog"
      title={t('schedule.content.availabilityCloseTitle')}
      subTitle={t('schedule.content.availabilityCloseSubtitle')}
      onClose={onClose}
      cancelOptions={{
        dataTestId: 'schedule-content-actions-availability-request-alert-cancel-button',
        label: t('hiring-dashboard-common:common.cancel'),
        onClick: onClose,
      }}
      submitOptions={{ label: t('hiring-dashboard-common:common.continue'), onClick: onContinue }}
    >
      {t('schedule.content.availabilityCloseBody')}
    </Dialog>
  );
};

export default AvailabilityCloseAlertModal;
